import { AUTH_ROLES, STUDENT_REQUEST_ACTIONS } from "../../../util/constants"
import { MuiIcons } from '@osu/react-ui'; 
import DialogAssign from "./DialogAssign";
import DialogReassign from "./DialogReassign";
import DialogUnassign from "./DialogUnassign";
import DialogConflictOfInterest from "./DialogConflictOfInterest";
import DialogRestart from "./DialogRestart";
import DialogAdminOverride from "./DialogAdminOverride";
import DialogSaveReview from "./DialogSaveReview";

import DialogStudentRequestApproveAppeal from "./DialogStudentRequestApproveAppeal";
import DialogStudentRequestApproveProgramChangeWithdrawal from "./DialogStudentRequestApproveProgramChangeWithdrawal";

export const menuItemsEnum = [
    {
        label: "Conflict of Interest",
        type: "CONFLICT_OF_INTEREST",
        roles: [AUTH_ROLES.HONORS_REVIEWER, AUTH_ROLES.SCHOLARS_REVIEWER, AUTH_ROLES.HONORS_ADMIN, AUTH_ROLES.SCHOLARS_ADMIN],
        icon: <MuiIcons.Error />,
        specialCaseFilterFns: [ extraInfo => extraInfo.isAssignedReviewer ],
        message: "You are reporting a conflict with this application.",
        component: DialogConflictOfInterest,
    },
    {
        label: "Resume Later",
        type: "RESUME_LATER",
        roles: [AUTH_ROLES.HONORS_REVIEWER, AUTH_ROLES.SCHOLARS_REVIEWER, AUTH_ROLES.HONORS_ADMIN, AUTH_ROLES.SCHOLARS_ADMIN, AUTH_ROLES.HONORS_SEASONAL_MANAGER],
        icon: <MuiIcons.Schedule />,
        specialCaseFilterFns: [ extraInfo => extraInfo.isAssignedReviewer ],
        message: "You are saving your work and will be able to resume later.",
        component: DialogSaveReview,
    },
    {
        label: "Assign Reviewer",
        type: "ASSIGN_REVIEWER",
        roles: [AUTH_ROLES.HONORS_ADMIN, AUTH_ROLES.SCHOLARS_ADMIN, AUTH_ROLES.HONORS_SEASONAL_MANAGER],
        icon: <MuiIcons.PersonAdd />,
        specialCaseFilterFns: [ isInProgress, isAssignable, showButtonIfNotCompleteOrCancelled],
        component: DialogAssign,
    },
    {
        label: "Reassign Reviewer",
        type: "REASSIGN_REVIEWER",
        roles: [AUTH_ROLES.HONORS_ADMIN, AUTH_ROLES.SCHOLARS_ADMIN, AUTH_ROLES.HONORS_SEASONAL_MANAGER],
        icon: <MuiIcons.SyncAlt />,
        specialCaseFilterFns: [ isInProgress, hasUnassignableReviewers, showButtonIfNotCompleteOrCancelled ],
        // message: "Choose an existing reviewer and a new reviewer from the list below to reassign to this application.",
        component: DialogReassign,
    },
    {
        label: "Unassign Reviewer",
        type: "UNASSIGN_REVIEWER",
        roles: [AUTH_ROLES.HONORS_ADMIN, AUTH_ROLES.SCHOLARS_ADMIN, AUTH_ROLES.HONORS_SEASONAL_MANAGER],
        icon: <MuiIcons.Remove />,
        specialCaseFilterFns: [ isInProgress, hasUnassignableReviewers ],
        component: DialogUnassign,
    },
    {
        label: "Administrative Recommendation",
        type: "ADMINISTRATIVE_RECOMMENDATION",
        roles: [AUTH_ROLES.HONORS_ADMIN, AUTH_ROLES.SCHOLARS_ADMIN],
        icon: <MuiIcons.SupervisedUserCircle />,
        specialCaseFilterFns: [ canAdminOverride, ],
        component: DialogAdminOverride,
    },
    {
        disabled: process.env.REACT_APP_ACTIONSMENU_RESTART_DISABLED === "true",
        label: "Restart Evaluation",
        type: "RESTART_EVALUATION",
        roles: [AUTH_ROLES.HONORS_ADMIN, AUTH_ROLES.SCHOLARS_ADMIN],
        icon: <MuiIcons.RotateLeft />,
        specialCaseFilterFns: [ showButtonIfNotCompleteOrCancelled ],
        message: "You are cancelling the current evaluation and starting a new one.",
        component: DialogRestart,
    },
    {
        label: "Prioritize Application",
        type: "PRIORITIZE_APPLICATION",
        roles: [],
        icon: <MuiIcons.AssignmentLate />, 
        specialCaseFilterFns: [ notPriorityApplication ],
        message: "This will prioritize the application for all current and future reviewers.",
    },
    {
        label: "Approve Student Appeal Request",
        type: "APPROVE_APPEAL_REQUEST",
        roles: [AUTH_ROLES.HONORS_ADMIN, AUTH_ROLES.SCHOLARS_ADMIN],
        icon: <MuiIcons.CheckCircle />, 
        specialCaseFilterFns: [ appealRequested, studentRequestIsActive ],
        message: "This will approve the appeal request for the application.",
        component: (props) => <DialogStudentRequestApproveAppeal {...props} buttonLabel="Submit" isApproved={true} requestType={STUDENT_REQUEST_ACTIONS.APPEAL.KEY} />
    },
    {
        label: "Deny Student Appeal Request",
        type: "REMOVE_APPEAL_REQUEST",
        roles: [AUTH_ROLES.HONORS_ADMIN, AUTH_ROLES.SCHOLARS_ADMIN],
        icon: <MuiIcons.Cancel />, 
        specialCaseFilterFns: [ appealRequested, studentRequestIsActive ],
        message: "This will deny the appeal request for the application.",
        component: (props) => <DialogStudentRequestApproveAppeal {...props} buttonLabel="Submit" requestType={STUDENT_REQUEST_ACTIONS.APPEAL.KEY} />
    },
    {
        label: "Approve Student Withdraw Request",
        type: "APPROVE_WITHDRAW_REQUEST",
        roles: [AUTH_ROLES.HONORS_ADMIN, AUTH_ROLES.SCHOLARS_ADMIN],
        icon: <MuiIcons.CheckCircle />, 
        specialCaseFilterFns: [ withdrawRequested, studentRequestIsActive ],
        message: "This will approve the withdraw request for the application.",
        component: (props) => <DialogStudentRequestApproveProgramChangeWithdrawal {...props} buttonLabel="Submit" requestType={STUDENT_REQUEST_ACTIONS.WITHDRAW.KEY} />
    },
    {
        label: "Cancel Student Withdraw Request",
        type: "CANCEL_WITHDRAW_REQUEST",
        roles: [AUTH_ROLES.HONORS_ADMIN, AUTH_ROLES.SCHOLARS_ADMIN],
        icon: <MuiIcons.Cancel />, 
        specialCaseFilterFns: [ withdrawRequested, studentRequestIsActive ],
        message: "This will cancel the withdraw request for the application.",
        component: (props) => <DialogStudentRequestApproveAppeal {...props} buttonLabel="Submit" requestType={STUDENT_REQUEST_ACTIONS.WITHDRAW.KEY} />
    },
    {
        label: "Approve Student Program Change Request",
        type: "APPROVE_PROGRAM_CHANGE_REQUEST",
        roles: [AUTH_ROLES.HONORS_ADMIN, AUTH_ROLES.SCHOLARS_ADMIN],
        icon: <MuiIcons.CheckCircle />, 
        specialCaseFilterFns: [ programChangeRequested, studentRequestIsActive ],
        message: "This will approve the program change request for the application.",
        component: (props) => <DialogStudentRequestApproveProgramChangeWithdrawal {...props} buttonLabel="Submit" requestType={STUDENT_REQUEST_ACTIONS.PROGRAM_CHANGE.KEY} />
    },
    {
        label: "Deny Student Program Change Request",
        type: "REMOVE_PROGRAM_CHANGE_REQUEST",
        roles: [AUTH_ROLES.HONORS_ADMIN, AUTH_ROLES.SCHOLARS_ADMIN],
        icon: <MuiIcons.Cancel />, 
        specialCaseFilterFns: [ programChangeRequested, studentRequestIsActive ],
        message: "This will deny the program change request for the application.",
        component: (props) => <DialogStudentRequestApproveAppeal {...props} buttonLabel="Submit" requestType={STUDENT_REQUEST_ACTIONS.PROGRAM_CHANGE.KEY} />
    },
    {
        label: "Deny Preference Change Request",
        type: "DENY_PREFERENCE_CHANGE_REQUEST",
        roles: [AUTH_ROLES.SCHOLARS_ADMIN],
        icon: <MuiIcons.Cancel />, 
        specialCaseFilterFns: [ preferenceChangeRequested, studentRequestIsActive ],
        message: "This will deny the preference change request for the application.",
        component: (props) => <DialogStudentRequestApproveAppeal {...props} buttonLabel="Submit" requestType={STUDENT_REQUEST_ACTIONS.PREFERENCE_CHANGE.KEY} />
    },

    // TODO Fix icons for below
    // {
    //     label: "Create Training",
    //     type: "CREATE_TRAINING",
    //     roles: [AUTH_ROLES.HONORS_ADMIN, AUTH_ROLES.SCHOLARS_ADMIN],
    //     icon: <MuiIcons.AssignmentIcon />,
    //     specialCaseFilterFns: [ applicantTrainingDoesntExist, ],
    //    message: "Choose from the options below to create a training application for reviewers.",
    // },
    // {
    //     label: "Assign Trainee",
    //     type: "ASSIGN_TRAINEE",
    //     roles: [AUTH_ROLES.HONORS_ADMIN, AUTH_ROLES.SCHOLARS_ADMIN],
    //     icon: <MuiIcons.AssignmentIcon />,   
    //     includeOnTrainingPage: true,
    //     specialCaseFilterFns: [ isTrainingPageOnly, ],
    //    message: "Choose from the options below to assign a training application for reviewers.",
    // },
    // {
    //     label: "Unassign Trainee",
    //     type: "UNASSIGN_TRAINEE",
    //     roles: [AUTH_ROLES.HONORS_ADMIN, AUTH_ROLES.SCHOLARS_ADMIN],
    //     icon: <MuiIcons.HighlightOffIcon />,
    //     includeOnTrainingPage: true,
    //     specialCaseFilterFns: [ isTrainingPageOnly, ],
    //    message: "Choose a reviewer from the list below to unassign from this training application.",
    // }
];

// Special case functions; allows for more fine-grain control of menu items in different states
//

// // Show ONLY on the training page menu
// function isTrainingPageOnly(extraInfo) { return extraInfo.isTraining; }

// // Show ONLY if there isn't already one created
// function applicantTrainingDoesntExist(extraInfo) { return extraInfo.applicantTrainingDoesntExist; }

function notPriorityApplication(extraInfo) { return !extraInfo.priority }

function canAdminOverride(extraInfo) { return extraInfo.canAdminOverride && !extraInfo.isInProgress; }

function isInProgress(extraInfo) { return extraInfo.isInProgress; }

function hasUnassignableReviewers(extraInfo) { return extraInfo.hasUnassignableReviewers; }

function isAssignable(extraInfo) { return extraInfo.assignable === true; }

function studentRequestIsActive(extraInfo) { return extraInfo.studentRequestIsActive === "Yes"; }

function appealRequested(extraInfo) { return extraInfo.appealRequested }

function withdrawRequested(extraInfo) { return extraInfo.withdrawRequested }

function programChangeRequested(extraInfo) { return extraInfo.programChangeRequested }

function preferenceChangeRequested(extraInfo) { return extraInfo.preferenceChangeRequested }

function showButtonIfNotCompleteOrCancelled(extraInfo) {
    return !(extraInfo.isApplicationFinalized === true || extraInfo.isApplicationCancelled === true);    
}